export class Broker {
    constructor() {
        this.id = null;
        this.name = '';
        this.dateCreated = '';
        this.dateModified = '';
        this.modifiedBy = 'BLC System';
    }
    id: number;
    name: string;
    dateCreated: string | Date;
    dateModified: string | Date;
    modifiedBy: string;
}
